import type { ShopDto, UpdateShopReturnReasonDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateReturnReason(shop: ShopDto, reasonId: string) {
  const invalidateShop = useInvalidateShop(shop.id);
  return useApiMutation("patch", "/shops/{shopId}/reasons/{reasonId}", {
    invalidate: invalidateShop,
    mapVariables: (variables: UpdateShopReturnReasonDto) => ({
      params: { path: { shopId: shop.id, reasonId } },
      body: variables,
    }),
  });
}
